/* ============================================================
   penovia-kollektion.js — eigene Datei (Ebene B)
   Baustein 5, 01.09.2026.

   Markup: sections/penovia-kollektion.liquid
           snippets/penovia-kollektion-filter.liquid

   Bewusst wenig: Das Filtern selbst macht der Server. Die Adresse ist
   das Ergebnis, Vor/Zurueck und Lesezeichen arbeiten deshalb von
   selbst. Ohne dieses Skript bleibt die Seite vollstaendig bedienbar —
   dann schickt der Knopf "Filter anwenden" das Formular ab.

   Vier Aufgaben:
     1. Kaestchen anklicken schickt sofort ab (der Knopf faellt weg)
     2. Farblinks um die aktuelle Adresszeile ergaenzen
     3. Sortierung wechseln
     4. Schublade unter 992px auf und zu

   Die Vorlage des Themes (assets/collection.js) tat das ueber Ajax und
   History.js — und tauschte dabei .grid-uniform aus, also die
   Rasteransicht. Der Shop stand auf Listenansicht; sichtbar aenderte
   sich also nichts. Die Seitenzahlen wurden nie mitgetauscht.
   ============================================================ */

(function () {
  'use strict';

  function los() {
    var form = document.getElementById('penovia-filterform');

    /* ---------- 1. Filter ---------- */
    if (form) {
      /* Leere Preisfelder gehoeren nicht in die Adresse: sonst haengt an
         jeder gefilterten Seite ein "filter.v.price.gte=" ohne Wert.
         Das deutsche Komma wird zum Punkt — Shopify erwartet ihn. */
      form.addEventListener('submit', function () {
        var zahlen = form.querySelectorAll('.penovia-filter__preis input');
        for (var i = 0; i < zahlen.length; i++) {
          var wert = zahlen[i].value.replace(',', '.').trim();
          if (wert === '') zahlen[i].disabled = true;
          else zahlen[i].value = wert;
        }
      });

      /* Am Dokument horchen, nicht am Formular: die Farbleiste steht
         ueber dem Raster und damit ausserhalb des <form>. Ihre Felder
         gehoeren ueber form="penovia-filterform" trotzdem dazu — aber
         ihr change-Ereignis steigt nicht zum Formular auf, weil das
         nicht ihr Vorfahre ist. */
      document.addEventListener('change', function (e) {
        var z = e.target;
        if (!z || z.type !== 'checkbox') return;
        if (z.form !== form) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });

      /* Der Knopf ist der Weg ohne JavaScript. Mit JavaScript waere er
         ein zweiter, langsamerer Weg zum selben Ziel — weg damit. Die
         Preisfelder behalten ihren eigenen Knopf: ein Zahlenfeld hat
         keinen Moment, an dem der Kunde "fertig" gesagt hat. */
      var knopf = form.querySelector('.penovia-filter__abschicken');
      if (knopf) knopf.hidden = true;
    }

    /* ---------- 2. Farblinks ---------- */

    /* Die Farbe wird ueber die Schlagwortadresse gefiltert
       (/collections/kugelschreiber/farbe-rot), Preis und Sortierung
       stehen dagegen in der Adresszeile. Im Liquid laesst sich die
       Adresszeile nicht auslesen — hier schon. Ohne diesen Zusatz
       verlore ein Farbwechsel die Preisspanne.

       Der Link im Markup ist bereits vollstaendig; hier kommt nur
       etwas dazu. Ohne JavaScript filtert die Farbe also weiter,
       nur eben allein. */
    var suche = window.location.search;
    if (suche && suche.length > 1) {
      var farblinks = document.querySelectorAll('[data-penovia-farblink]');
      for (var k = 0; k < farblinks.length; k++) {
        var ziel = farblinks[k].getAttribute('href');
        if (ziel && ziel.indexOf('?') < 0) farblinks[k].setAttribute('href', ziel + suche);
      }
    }

    /* ---------- 3. Sortierung ---------- */
    var sortieren = document.getElementById('penovia-sortierung');
    if (sortieren) {
      sortieren.addEventListener('change', function () {
        var adresse = new URL(window.location.href);
        if (sortieren.value) adresse.searchParams.set('sort_by', sortieren.value);
        else adresse.searchParams.delete('sort_by');
        /* Nach einem Sortierwechsel wieder auf Seite 1 — Seite 7 einer
           anderen Reihenfolge ist keine sinnvolle Antwort. */
        adresse.searchParams.delete('page');
        window.location.href = adresse.toString();
      });
    }

    /* ---------- 4. Schublade auf dem Handy ---------- */
    var spalte = document.getElementById('penovia-filterspalte');
    if (!spalte) return;
    var auf = document.querySelector('[data-penovia-filter-auf]');
    var zuKnoepfe = document.querySelectorAll('[data-penovia-filter-zu]');
    var AUF = 'penovia-kollektion__spalte--auf';

    function oeffne() {
      spalte.classList.add(AUF);
      document.body.classList.add('penovia-filter-offen');
    }
    function schliesse() {
      spalte.classList.remove(AUF);
      document.body.classList.remove('penovia-filter-offen');
    }

    if (auf) auf.addEventListener('click', oeffne);
    for (var j = 0; j < zuKnoepfe.length; j++) {
      zuKnoepfe[j].addEventListener('click', schliesse);
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') schliesse();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los);
  } else {
    los();
  }
})();
